<template>
    <v-overlay
        color="white"
        opacity="0.8"
        :value="loadingState"
        z-index="99"
        class="text-center"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <p class="black--text">{{ betMessage }}</p>
        <div class="loader-wrapper">
            <div class="loader">
                <div v-if="!isPremiumSports && !closedByTimer" class="num">
                    {{ betValue }}
                </div>
                <v-img
                    :src="require('@/assets/images/loader-new.gif')"
                    :lazy-src="require('@/assets/images/loader-new.gif')"
                ></v-img>
            </div>
        </div>
    </v-overlay>
</template>

<script>
import { mapState } from "vuex"

export default {
    computed: {
        ...mapState({
            closedByTimer: (state) => state.placeBet.closedByTimer
        }),
        bettingType() {
            return this.$store.state.placeBet.bettingType
        },
        isPremiumSports() {
            return this.bettingType === "premiumsports"
        },
        loadingState() {
            return this.isPremiumSports
                ? this.$store.state.placeBet.loading
                : this.$store.state.betLoading.loading
        },
        betMessage() {
            return this.isPremiumSports || this.closedByTimer
                ? "Your bet is being processed..."
                : "Your bet will be placed in..."
        },
        betValue() {
            return this.$store.state.betLoading.value
        }
    }
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
    display: flex;
    justify-content: center;
}

.loader {
    position: relative;
    width: 6rem;
    height: 6rem;
}

.num {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: black;
}
</style>
